import { useMemo } from 'react';
import { ActiveTam, CLevelMarginRankingMode, CLevelMarginRankingRow, CLevelSynthesisRow } from '../types/primes';
import {
  buildAnnualMarginAmountByTam,
  buildCLevelMarginRankingRows,
  buildLifetimeAmountByTam,
  buildLifetimeDisplayAmountByTam,
} from '../utils/lifetimeMargin.utils';
import { useLifetimeMarginCumuls } from './useLifetimeMarginCumul';

export const useCLevelMarginRanking = (
  activeTams: ActiveTam[],
  synthesisRows: CLevelSynthesisRow[],
  mode: CLevelMarginRankingMode,
) => {
  const { cumuls, loading: lifetimeLoading, error: lifetimeError } = useLifetimeMarginCumuls();

  const rows = useMemo((): CLevelMarginRankingRow[] => {
    if (activeTams.length === 0) {
      return [];
    }

    const amountByTamEmail =
      mode === 'annual' ? buildAnnualMarginAmountByTam(synthesisRows) : buildLifetimeAmountByTam(cumuls);

    return buildCLevelMarginRankingRows({ activeTams, amountByTamEmail });
  }, [activeTams, cumuls, mode, synthesisRows]);

  const loading = mode === 'lifetime' ? lifetimeLoading : synthesisRows.some((row) => row.rowStatus === 'loading');
  const lifetimeDisplayAmountByTamEmail = useMemo(() => buildLifetimeDisplayAmountByTam(cumuls), [cumuls]);

  return {
    rows,
    loading,
    error: mode === 'lifetime' ? lifetimeError : undefined,
    lifetimeDisplayAmountByTamEmail,
    lifetimeLoading,
  };
};
